module.exports = __webpack_public_path__ + "img/bao_dampning.f0eb6680.jpg";